/* eslint-disable jsx-a11y/anchor-has-content */
import { Box, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import React from 'react'
// import {
//   Image,
// } from '@react-pdf/renderer'

let content = ''

const useStyles = makeStyles(() => ({
  root: {
    marginTop: '50px',
  },
  fileWrapper: {
    marginBottom: '2rem',
    // border: '2px dashed orange',
    width: '10vw',
    height: '200px',
    '@media (max-width: 800px)': {
      width: '100%',
      marginBottom: '22vw',
      // height: '100px',
    },
  },
  file: {
    width: '100%',
    height: '200px',
    objectFit: 'contain',
  },
  fileContainer: {
    width: '100%',
    margin: '20px auto',
  },
  pdfText: {
    fontSize: '1vw',
    fontWeight: '600',
    width: '100%',
    textAlign: 'center',
    '@media (max-width: 900px)': {
      fontSize: '2.2vw',
    },
  },
}))

const UserEventFile = ({ file }) => {
  const classes = useStyles()

  switch (true) {
    case file?.mimeType === 'video/mp4':
      content = (
        <video style={{ width: '100%' }} controls>
          <source src={file?.url} type={file.mimeType} />
          <track src="captions_en.vtt" kind="captions" srcLang="en" label="english_captions" />
        </video>
      )
      break

    case file?.mimeType === 'audio/mpeg':
      content = (
        <audio controls>
          <source src={file?.url} type={file.mimeType} />
          <track src="captions_en.vtt" kind="captions" srcLang="en" label="english_captions" />
        </audio>
      )
      break

    case file?.mimeType === 'application/pdf':
      content = (
        <>
          <a href={file?.url} target="_blank" rel="noreferrer" download>
            <p className={classes.pdfText}>PDF</p>
          </a>
          <div
            scrolling="no"
            style={{
              position: 'relative', width: '300px', height: '200px',
            }}
          >

            <object height="100%" width="100%" style={{ overflowY: 'hidden !important', marginLeft: '89px' }} data={file?.url} type="application/pdf">
              {/* <div>No online PDF viewer installed</div> */}
            </object>

            <a
              href={file?.url}
              scrolling="no"
              style={{
                position: 'absolute', right: 0, top: 0, zIndex: 700, width: '100%', height: '100%',
              }}
              target="_blank"
              rel="noreferrer"
              download
            />
          </div>
        </>
      )
      break

    case file?.mimeType === 'image/png' || file?.mimeType === 'image/jpeg':
      content = (
        <>
          <a href={file?.url} target="_blank" rel="noreferrer" download>
            <img
              src={file?.url}
              className={classes.file}
              alt="W3Schools"
              width="104"
              height="142"
            />
          </a>
        </>
      )
      break

    default:
      content = (
        <Box>
          <Typography
            variant="subtitle1"
          >
            فایل ارسالی
          </Typography>
        </Box>
      )
      break
  }
  return (
    <div className={classes.fileContainer}>
      {content}
    </div>
  )
}

export default UserEventFile
